import { createContext, useState } from 'react';

export const ProductsContext = createContext({
  products: [],
  categories: [],
  handleProducts: (products) => null,
  getProductsByCategory: (category) => null,
  handleCategories: (categories) => null,
  getProduct: (productId) => null
});

export const ProductsContextProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const handleProducts = (products) => {
    setProducts(products);
  }

  const getProductsByCategory = (category) => {
    if (products.length === 0) {
      return [];
    } else {
      return products.filter(product => product.category === category);
    }
  }

  const handleCategories = (categories) => {
    setCategories(categories);
  }

  const getProduct = (productId) => {
    return products.find(p => p.id === productId);
  }

  return (
    <ProductsContext.Provider value={{
      products,
      categories,
      handleProducts,
      getProductsByCategory,
      handleCategories,
      getProduct
    }}>
      {children}
    </ProductsContext.Provider>
  )
}